import React from 'react';
import slabLogo from '../images/slab-logo-red-320.png';

// TODO: If we will only use className, remove the `extends` part.
interface SlabLogoProps extends React.HTMLAttributes<HTMLImageElement> {
  className?: string;
}

const SlabLogo = (props: SlabLogoProps) => {
  return <img src={slabLogo} alt="Slab Logo" {...props} />;
};

export default SlabLogo;
